import React from 'react'

function About() {
  return (
    <div>
      <h2>
        أكاديمية طويق هي مؤسسة تعليمية مقرّها مدينة الرياض، أعلن الاتحاد السعودي
        للأمن السيبراني والبرمجة و الدرونز عن تأسيسها في أغسطس 2019، وتتخذ من
        جامعة الأميرة نورة بنت عبد الرحمن مقرًا لها. تُعد الأكاديمية الأولى
        للتقنيات المتقدمة في المملكة العربية السعودية، من خلال تقديم مستوى عال
        من البرامج التدريبية على التقنية المتقدمة والمعسكرات في البرمجة، وهندسة
        البرمجيات، وعلوم البيانات، والأمن السيبراني.تسعى نحو تقليص الفجوة بين
        متطلبات سوق العمل، ومهارات الأفراد في مجالات تقنية المعلومات، بالتركيز
        على بناء القدرات، وتقديم خبرات جديدة، وتطوير المهارات. تعمل على تزويد
        سوق العمل بمحترفين رقميين يسعون للحصول على وظائف بمجال التقنية في
        الشركات.
      </h2>
    </div>
  );
}

export default About